import { useState, useCallback } from 'react';

/**
 * Tracks the lifecycle of background save operations so the UI can show an
 * honest "Saving… / Saved / Save failed" indicator instead of failing silently.
 *
 * Wrap any persistence promise with `track`:
 *   track(updateLayoutApi(id, layout));
 *
 * status transitions: 'idle' -> 'saving' -> 'saved' | 'error'.
 * The original resolved value is passed through, and rejections are re-thrown
 * so existing error handling (e.g. toast) keeps working.
 */
export default function useSaveStatus() {
  const [status, setStatus] = useState('idle');

  const track = useCallback((promise) => {
    setStatus('saving');
    return Promise.resolve(promise).then(
      (value) => {
        setStatus('saved');
        return value;
      },
      (error) => {
        setStatus('error');
        throw error;
      }
    );
  }, []);

  return { status, track };
}
